import React from "react";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import { useNavigate, Link } from "react-router-dom";

import FormRegistro from "../../components/FormRegistro";

const Item = styled(Box)(({ theme }) => ({
  backgroundColor: "#121212",
  color: theme.palette.text.secondary,
  height: "100vh",
}));

export default function RegistroPage2({ sessionActive }) {
  const navigate = useNavigate();

  if (sessionActive) {
    navigate("/dashboard");
  }

  return (
    <>
      <Container maxWidth="xl">
        <Item sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid md={6} xs={12}>
              <Typography
                variant="h4"
                gutterBottom
                className="mt-6 has-text-weight-semibold"
              >
                ¡BIENVENIDO A WE FUNDS TRADE!
              </Typography>
              <p>
                En
                <span style={{ color: "#FFF", fontWeight: "bold" }}>
                  {" "}
                  WE FUNDS TRADE{" "}
                </span>
                queremos llevarte a ser un inversor rentable, en nuestra firma
                contamos con expertos que te llevaran en esta camino de
                inversiones dispuestos en ayudarte.
              </p>

              <br />

              <p>Accede a nuestra plataforma de inversión desde $10 USD</p>

              <br />

              <p>
                En We Funds Trade puedes crear y gestionar tus portafolios con
                acceso a mercados de acciones, materias primas y estrategias de
                diversificación controlada. Nuestro sistema te permite: Generar
                ingresos adicionales Construir portafolios organizados
                Capitalizar tu patrimonio de forma gradual Diseñar un plan
                financiero a largo plazo
              </p>

              <div className="has-text-centered"></div>
            </Grid>
            <Grid
              md={6}
              xs={12}
              style={{ backgroundColor: "#1e1e1e", height: "100vh" }}
            >
              <Typography
                variant="h4"
                gutterBottom
                className="text-center mt-4"
              >
                Regístrate
              </Typography>
              <FormRegistro />
              <div style={{ textAlign: "center", marginTop: 20 }}>
                <Link to="/login" style={{ color: "#fff" }}>
                  Iniciar Sesión
                </Link>
              </div>
            </Grid>
          </Grid>
        </Item>
      </Container>
    </>
  );
}
